import { Link } from 'react-router-dom'
import { useI18n } from '../i18n/I18nProvider'
import { Notice } from '../ui/controls'

/**
 * Where Stripe sends the browser back to.
 *
 * **Neither page grants anything.** The unlock is granted by the webhook, inside the transaction
 * that also writes the payment row (决议 §4.0) — a browser that was redirected here proves only
 * that a browser was redirected here. So the wording says the unlock is *being confirmed*, which
 * is both true and the only thing this page can honestly claim.
 */
export function PaymentSuccess() {
  const { t } = useI18n()

  return (
    <div className="page stack">
      <h1>{t('payment.success.title')}</h1>
      <Notice>{t('payment.success.body')}</Notice>

      <div className="row-links">
        <Link className="primary as-link" to="/matches">
          {t('payment.viewMatches')}
        </Link>
        <Link to="/matching">{t('payment.backToMatching')}</Link>
      </div>
    </div>
  )
}

export function PaymentCancelled() {
  const { t } = useI18n()

  return (
    <div className="page stack">
      <h1>{t('payment.cancelled.title')}</h1>
      <Notice>{t('payment.cancelled.body')}</Notice>

      <Link className="primary as-link" to="/matching">
        {t('payment.backToMatching')}
      </Link>
    </div>
  )
}
